import * as React from "react";
import { useSearchParams } from "react-router-dom";

import { loginCustomerParams } from "../api/google-ads";

// Pages under a sub-account carry its manager in the URL, and every link
// between them has to keep it.
export function useGoogleAdsLoginCustomerId() {
  const [searchParams] = useSearchParams();
  const loginCustomerId = searchParams.get("login-customer-id");

  const withLoginCustomerId = React.useCallback(
    (path: string) => googleAdsAccountPath(path, loginCustomerId),
    [loginCustomerId],
  );

  return { loginCustomerId, withLoginCustomerId };
}

export const googleAdsAccountPath = (
  path: string,
  loginCustomerId: string | null,
) => {
  const search = new URLSearchParams(
    loginCustomerParams(loginCustomerId),
  ).toString();
  return search ? `${path}?${search}` : path;
};
